module.exports = __webpack_public_path__ + "img/射干.c2888cf7.jpg";